import { APP_CALLBACK_PROTOCOL } from './linkedinNative';

export const APP_CALENDAR_CALLBACK = 'com.ironforums.app://calendar/callback';

export function parseCalendarCallback(rawUrl: string): {
  state: string;
  error: string | null;
  code: string | null;
} | null {
  let url: URL;
  try {
    url = new URL(rawUrl);
  } catch {
    return null;
  }
  if (
    url.protocol !== APP_CALLBACK_PROTOCOL
    || url.hostname !== 'calendar'
    || url.pathname !== '/callback'
  ) {
    return null;
  }
  const state = url.searchParams.get('state') || '';
  if (!state) return null;
  return {
    state,
    error: url.searchParams.get('error'),
    code: url.searchParams.get('code'),
  };
}

export function calendarAppCallbackUrl(params: {
  state: string;
  code?: string;
  error?: string;
}): string {
  const url = new URL(APP_CALENDAR_CALLBACK);
  url.searchParams.set('state', params.state);
  if (params.code) url.searchParams.set('code', params.code);
  if (params.error) url.searchParams.set('error', params.error);
  return url.toString();
}
